<div class="step-container">
  <h2 class="step-title">Verificación facial</h2>

  <!-- Loading: redirecting to SANII -->
  <div *ngIf="loading" class="loading-container">
    <mat-spinner diameter="50"></mat-spinner>
    <p>Redirigiendo a la verificación facial...</p>
  </div>

  <!-- Error -->
  <div *ngIf="errorMessage" class="error-container">
    <div class="error-message">
      <mat-icon>error_outline</mat-icon>
      <span>{{ errorMessage }}</span>
    </div>
    <button mat-raised-button color="primary" class="action-button" (click)="retry()">
      Reintentar
    </button>
  </div>
</div>
